import { Grid, Stack, Text } from '@mantine/core'
import { CartDeviceAdvertisement } from '../../models/Checkout/CartDeviceAdvertisement'
import {
  getCostFromDateRange,
  getDateStringFromRange,
} from '../../utils/dateUtils'

interface ConfirmAdRemovalModalContentProps {
  deviceAdvertisement: CartDeviceAdvertisement
}

function ConfirmAdRemovalModalContent(
  props: ConfirmAdRemovalModalContentProps,
) {
  const { deviceAdvertisement } = props

  const getTimePeriodDisplay = () => {
    if (!deviceAdvertisement.numberOfDaysToRunAd) {
      return getDateStringFromRange(
        [deviceAdvertisement.startDateLocal, deviceAdvertisement.endDateLocal],
        deviceAdvertisement.numberOfDaysToRunAd,
      )
    }

    switch (deviceAdvertisement.numberOfDaysToRunAd) {
      case 7:
        return '1 week'
      case 14:
        return '2 weeks'
      case 30:
        return '1 month'
      case 90:
        return '3 months'
      default:
        return getDateStringFromRange(
          [
            deviceAdvertisement.startDateLocal,
            deviceAdvertisement.endDateLocal,
          ],
          deviceAdvertisement.numberOfDaysToRunAd,
        )
    }
  }

  return (
    <Stack>
      <Text size='sm'>
        Are you sure you want to remove this advertisement from your cart?
      </Text>
      <Grid>
        <Grid.Col span={3}>
          <Text fw={500}>Location:</Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text>{`${deviceAdvertisement.locationName} - ${deviceAdvertisement.device.name}`}</Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text fw={500}>Ad Name:</Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text>{deviceAdvertisement.advertisement.name}</Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text fw={500}>Duration:</Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text>{getTimePeriodDisplay()}</Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text fw={500}>Total:</Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text fw={700}>
            $
            {getCostFromDateRange(
              deviceAdvertisement.device.dailyPrice,
              [
                deviceAdvertisement.startDateLocal,
                deviceAdvertisement.endDateLocal,
              ],
              deviceAdvertisement.businessHours,
              deviceAdvertisement.numberOfDaysToRunAd,
              deviceAdvertisement.device.weeklyPrice,
              deviceAdvertisement.device.monthlyPrice,
            ).toFixed(2)}
          </Text>
        </Grid.Col>
      </Grid>
    </Stack>
  )
}

export default ConfirmAdRemovalModalContent
